import { render, staticRenderFns } from "./userBieyangai.vue?vue&type=template&id=29a60699&scoped=true&"
import script from "./userBieyangai.vue?vue&type=script&lang=js&"
export * from "./userBieyangai.vue?vue&type=script&lang=js&"
import style0 from "./userBieyangai.vue?vue&type=style&index=0&id=29a60699&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a60699",
  null
  
)

export default component.exports